module.exports = __webpack_public_path__ + "img/14.08a0a6be.png";